/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Legend_GrayInputs */

const en_pol_legend_gray = /** @type {(inputs: Pol_Legend_GrayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No written statement yet. Bystep still shows it, with a gray label and the date we checked.`)
};

const id_pol_legend_gray = /** @type {(inputs: Pol_Legend_GrayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pernyataan tertulis. Bystep tetap menampilkannya dengan label abu-abu dan tanggal pengecekan.`)
};

/**
* | output |
* | --- |
* | "No written statement yet. Bystep still shows it, with a gray label and the date we checked." |
*
* @param {Pol_Legend_GrayInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_legend_gray = /** @type {((inputs?: Pol_Legend_GrayInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Legend_GrayInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_legend_gray(inputs)
	return en_pol_legend_gray(inputs)
});